import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Application from '../Application/Application';
import Button from '../Button/Button';
import Dialog from '../Dialog/Dialog';
import Input from '../Input/Input';
import Group from '../Group/Group';
import Menu from '../Menu/Menu';
import Progressbar from '../Progressbar/Progressbar';
import DateTimeInput from '../DateTimeInput/DateTimeInput';
import TransitionGroup from '../TransitionGroup/TransitionGroup';

class DialogExample extends Component {

  state = {
    title: 'Custom dialog',
    ok: 'Allright!',
  };

  onAllRight = () => this.setState({ showCustomDialog: false });

  onChange = e => this.setState(e.target.value);

  onChangeDate = date => this.setState({ date });

  showInfoDialog = () =>
    Application.showInfoDialog('Info dialog', 'Info dialogs should be used to display informative messages.', 'OK',
      () => window.showAppInfo('OK'));

  showOkDialog = () =>
    Application.showOkDialog('OK dialog', "OK dialogs should only be used in rare cases. Do not use OK dialogs to notify user of successful operations.", 'OK', null);

  showWarningDialog = () =>
    Application.showWarningDialog('Delete item?', 'Warning dialogs should be displayed before "dangerous" operations such as delete, publish etc.', 'Delete', 'Cancel', null,
      () => window.showAppInfo('OK'),
      () => window.showAppInfo('Cancel'));

  showErrorDialog = () =>
    Application.showErrorDialog('Unable to publish', 'Error dialogs should be used to display error messages.', 'OK', 'Retry',
      () => window.showAppInfo('OK'),
      () => window.showAppInfo('Retry'));

  showChangeDialog = () =>
    Application.showWarningDialog('The document has been modified', 'Do you want to save changes?', 'Yes', 'No', 'Revert Changes',
      () => window.showAppInfo('Yes'),
      () => window.showAppInfo('No'),
      () => window.showAppInfo('Revert Changes'));

  showCustomDialog = () => this.setState({ showCustomDialog: true });

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Dialog.defaultProps} propTypes={Dialog.propTypes} propValues={this.state}>
          <Tip>These properties will affect the custom dialog only</Tip>
        </Properties>
        <Group>
          <Button iconName="info" onClick={this.showInfoDialog}>Info dialog</Button>
          <Button iconName="success" onClick={this.showOkDialog}>OK dialog</Button>
          <Button iconName="warning" onClick={this.showWarningDialog}>Warning dialog</Button>
          <Button iconName="error" onClick={this.showErrorDialog}>Error dialog</Button>
          <Button iconName="warning" onClick={this.showChangeDialog}>Change dialog</Button>
          <Button iconName="help" onClick={this.showCustomDialog}>Custom dialog</Button>
        </Group>
        <TransitionGroup in={this.state.showCustomDialog} className="animate-dialog">
          <Dialog {...this.state} okCallback={this.onAllRight} cancelCallback={this.onAllRight} discardCallback={this.onAllRight} onClose={this.onAllRight}>
            <Progressbar value={75}/>
            <Group className="custom-dialog-group">
              <DateTimeInput onChange={this.onChangeDate} selected={this.state.date}/>
              <Menu buttonClass="core-icon-button">
                <Button>Menu item 1</Button>
                <Button>Menu item 2</Button>
              </Menu>

            </Group>

              <Input label="Great input" infoMessage="Computer says no!" />

          </Dialog>
        </TransitionGroup>
        <SourceCode language="javascript" title="Example code">
          {
            'Application.showInfoDialog(\'This is an Info dialog\', "Use these dialogs to display information.", ' +
            '\'OK\', null,\n' +
            '  () => {\n' +
            '    // handle OK\n' +
            '  });\n' +
            '\n' +
            'Application.showOkDialog(\'This is an OK dialog\', "There\'s not much else to do here than press the OK button", ' +
            '\'OK\', null,\n' +
            '  () => {\n' +
            '    // handle OK\n' +
            '  });\n' +
            '\n' +
            'Application.showWarningDialog(\'This is an error dialog\', \'Something went wrong!\', \'OK\', ' +
            '\'Retry\',\n' +
            '  () => {\n' +
            '    // handle OK\n' +
            '  },\n' +
            '  () => {\n' +
            '    // handle Retry\n' +
            '  });\n' +
            '\n' +
            'Application.showError(\'This is a warning dialog\', \'Wow! Two options! Much impressive!\', \'OK\', ' +
            '\'Cancel\',\n' +
            '  () => {\n' +
            '    // handle OK\n' +
            '  },\n' +
            '  () => {\n' +
            '    // handle Cancel\n' +
            '  });\n' +
            '\n' +
            'Application.showWarningDialog(\'This is a Change dialog\', \'Do you want to save changes?\', \'Yes\', \'No\', ' +
            '\'Revert Changes\',\n' +
            '  () => {\n' +
            '    // handle Yes\n' +
            '  },\n' +
            '  () => {\n' +
            '    // handle No\n' +
            '  },\n' +
            '  () => {\n' +
            '    // handle Revert Changes\n' +
            '  });'
          }
        </SourceCode>
      </Example>
    );
  }

}

DialogExample.tags = 'lightbox';

export default DialogExample;
